/* eslint-disable max-len */
export default {
  MESSAGES: {
    CURRENT_DELIVERY_STATUS: 'Current delivery status',
    DATE: 'Date',
    DELIVERY_HISTORY: 'Delivery history',
    HOUR: 'Hour',
    OBSERVATIONS: 'Observations',
    STATUS: 'Status'
  }
};
